"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _tracking = require("settings-ui-app/utils/tracking");

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _ThemesContainer = _interopRequireDefault(require("./containers/ThemesContainer"));

var _default = _react.default.createElement(_reactRouter.Route, {
  path: _UrlPathParams.THEMES,
  component: _ThemesContainer.default,
  onEnter: (0, _tracking.trackScreenUsingSideNav)()
});

exports.default = _default;
module.exports = exports.default;